import { t } from '@avalara/bat-apps-shared/i18n';
import { SBox } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  h2 {
    font-size: 23px;
    line-height: 30px;
  }
  p {
    font-size: 14px;
    line-height: 18px;
  }
`;

const BillingSummary = () => (
  <Wrapper>
    <SBox className='secondary pad-all-md'>
      <h2 data-ref='buy.returns-thankyou.billing-summary.header' className='alt'>
        {t('client.headings.billing-summary')}
      </h2>
      <p data-ref='buy.returns-thankyou.billing-summary.content' className='pad-top-sm'>
        Moving forward, your payment method will be charged for each return we handle.
      </p>
    </SBox>
  </Wrapper>
);
export default BillingSummary;
